import { Component, OnInit, OnDestroy, ViewChild, OnChanges, AfterContentInit } from '@angular/core';
import {FadeZoomInTop} from "../../animations/fade-zoom-in-top.decorator";
import { LayoutService } from '../layout.service';
import { Subscription } from 'rxjs';
import { CreateCampaignModalComponent } from 'app/shared/create-campaign-modal/create-campaign-modal.component';
import { DeliveryInformationComponent } from 'app/shared/delivery-information/delivery-information.component';
import { DistributeDeliveryComponent } from 'app/shared/distribute-delivery/distribute-delivery.component';
import { ContributionsComponent } from 'app/shared/contributions/contributions.component';
import { BrandAllocation } from 'app/client-core/dtos/brand-allocation.models';
import { EditReasonComponent } from 'app/shared/edit-reason/edit-reason.component';
import { ProgramDto } from 'app/client-core/dtos/programs.model';
import { CreateNewTacticComponent } from 'app/shared/create-new-tactic/create-campaign-new-tactic.component';
import { ProgramDetailsTactic } from 'app/client-core/dtos/program-details';
import { FundingSourcesModalComponent } from 'app/shared/funding-sources-modal/funding-sources-modal.component';
import { ExpensesMindShareComponent } from 'app/shared/expenses-modal/expenses-mindshare-modal.component';
import { CommunicationRequestDetailsComponent } from 'app/shared/communication-request-details/communication-request-details.component';
import { NewCommunicationRequestComponent } from 'app/shared/new-communication-request/new-communication-request.component';
import { CreateCampaignCartModalComponent } from 'app/shared/campaign-cart-modal/campaign-cart-modal.component';
import { RetailerProfileDocDto } from 'app/client-core/dtos/retailers.model';
import { NewProfileVersionComponent } from 'app/shared/retailer-profile-new-version/retailer-profile-new-version.component';
import { AddressBookDeliveryInformationComponent } from 'app/shared/addressbook-delivery-information/addressbook-delivery-information.component';

const $ = jQuery;
@FadeZoomInTop()
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: [
    './main.scss'
  ]
})
export class MainLayoutComponent implements OnInit, OnDestroy, OnChanges, AfterContentInit {
  sideModalActive = false;
  showModalSubscriber: Subscription;
  hideModalSubscriber: Subscription;
  campaignThemeId: number;
  programId: number;
  showCampaignInfoSubscription: Subscription;
  modalHeight = 0;
  showCreateCampaignInfoSubscription: Subscription;
  showDeliveryInformation: Subscription;
  modalToShow = 'create';
  
  @ViewChild('createCampaign') createCampaign: CreateCampaignModalComponent;
  @ViewChild('deliveryInfo') deliveryInfo: DeliveryInformationComponent;
  @ViewChild('addressbookdeliveryInfo') addressbookdeliveryInfo: AddressBookDeliveryInformationComponent;
  @ViewChild('deliveryDistribution') deliveryDistribution: DistributeDeliveryComponent;
  @ViewChild('contributions') contributions: ContributionsComponent;
  @ViewChild('editReason') editReason: EditReasonComponent;
  @ViewChild('createTactic') createTactic: CreateNewTacticComponent;
  @ViewChild('fundingSources') fundingSources: FundingSourcesModalComponent;
  @ViewChild('mindshareModal') mindshareModal: ExpensesMindShareComponent;
  @ViewChild('communicationRequestDetails') communicationRequestDetails: CommunicationRequestDetailsComponent
  @ViewChild('newCommunicationRequest') newCommunicationRequest: NewCommunicationRequestComponent
  @ViewChild('campaignCartModal') campaignCartModal: CreateCampaignCartModalComponent
  @ViewChild('newVersionDTO') newVersionDTO: NewProfileVersionComponent;
  
  fromMyCampaigns: boolean;
  showJobsToBeDoneSubscription: Subscription;
  brandId: number;
  showContributionsSubscription: Subscription;
  title: any;
  budgetYear: any;
  brandAllocation: BrandAllocation;
  brandRetailerAllocationId: number;
  showEditReasonSubscription: Subscription;
  total: number;
  totalAtl: number;
  totalBtl: number;
  retailerId: number;
  retailerName: string;
  fromPrgramOverview: boolean;
  goToProgramDetails: boolean;
  showCreateTacticSubscription: Subscription;
  tacticDto: ProgramDetailsTactic;
  programStatusId: number;
  uniPriSMUpgrade: boolean;
  programTacticId: number;
  showFundingSourcesSubscription: Subscription;
  componentId: number;
  requestId: number;
  versionId: number;
  dto: RetailerProfileDocDto;
  showLoading: boolean;

  constructor(
    private layoutService: LayoutService
  ) { }

  ngOnChanges(changes): void {
    this.updateHeight();
  }

  ngAfterContentInit(): void {
    this.updateHeight();
  }

  updateHeight() {
    setTimeout(() => {
      this.modalHeight = $('#left-panel').height();
    }, 300);
  }

  ngOnInit() {
    this.updateHeight();
    this.hideModalSubscriber = this.layoutService.hideSideModal.subscribe(() => {
      this.updateHeight();
      this.sideModalActive = false;
    });

    this.showModalSubscriber = this.layoutService.showSideModal.subscribe(() => {
      this.updateHeight();
      this.sideModalActive = true;
      window.scroll(0, 0);
    });

    this.showCampaignInfoSubscription = this.layoutService.showCampaignThemeInfo.subscribe(id => {
      this.updateHeight();
      this.campaignThemeId = id;
      this.modalToShow = 'campaign-info';
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
    });

    this.showContributionsSubscription = this.layoutService.showContributions.subscribe(data => {
      this.updateHeight();
      this.brandId = data.brandId;
      this.title = data.title;
      this.budgetYear = data.budgetYear;
      this.modalToShow = 'contributions';
      this.sideModalActive = true;
      if (this.contributions) {
        this.contributions.search = ""; 
      }
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
    });

    this.showEditReasonSubscription = this.layoutService.showEditReason.subscribe(data => {
      this.updateHeight();
      
      this.brandAllocation = data.brandAllocation;
      if (this.brandAllocation) {
        const comment = this.brandAllocation.comment;
        this.brandAllocation.comment = comment;
      }
      this.title = data.title;
      this.brandRetailerAllocationId = data.brandRetailerAllocationId;
      this.modalToShow = 'edit-reason';
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      setTimeout(() => {
        // if (this.editReason) {
        //   this.editReason.loadProgram();
        // }
      }, 1000);
    });

    this.showJobsToBeDoneSubscription = this.layoutService.showJobsToBeDone.subscribe(data => {
      this.updateHeight();
      this.brandId = data.brandId;
      this.budgetYear = data.budgetYear,
      this.title = data.title;
      this.modalToShow = 'jobs';
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
    });

    this.showFundingSourcesSubscription = this.layoutService.showFundingSources.subscribe(data => {
      this.updateHeight();
      if (this.fundingSources) {
        this.fundingSources.clear();
      }
      this.programId = data.programId;
      this.budgetYear = data.budgetYear;
      this.retailerId = data.retailerId;
      this.modalToShow = 'funding-sources';
      this.sideModalActive = true;
      if (this.fundingSources) {
        this.fundingSources.selectedProgramId = data.programId;
        this.fundingSources.canShowJobsToBeDone = false;
        this.fundingSources.programId = data.programId;
        this.fundingSources.budgetYear = data.budgetYear;
        this.fundingSources.retailerId = data.retailerId;
        this.fundingSources.loadBrands(data.retailerId, data.budgetYear);
        this.fundingSources.loadFundingSourceDetails(data.programId);
        this.fundingSources.loadProgram(data.programId);
        this.fundingSources.checkUniPrismUpgrade(this.budgetYear);
      }
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
    });

    this.showCreateTacticSubscription = this.layoutService.showCreateTactic.subscribe(data => {
      console.log('reopen', data)
      this.updateHeight();
      setTimeout(() => {
        // this.createTactic.clear();
        this.createTactic.setupTactic();
        this.createTactic.loadTypes();
        
        if (data.tacticDto) {
          this.createTactic.tacticDto = data.tacticDto;
          this.createTactic.newtacticDto = data.tacticDto;
          this.createTactic.budgetYear = data.budgetYear;
        }
      }, 200);
      this.programStatusId = data.programStatusId;
      this.tacticDto = data.tacticDto;
      this.programId = data.programId;
      this.programTacticId = data.programTacticId;
      this.uniPriSMUpgrade = data.uniPriSMUpgrade;
      this.componentId = data.componentId;
      this.modalToShow = 'create-new-tactic';
      this.sideModalActive = true;
      this.budgetYear = data.budgetYear;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
    });

    this.showCreateCampaignInfoSubscription = this.layoutService.showCreateCampaignThemeInfo.subscribe((data) => {
      this.updateHeight();
      this.modalToShow = 'create-campaign';
      this.sideModalActive = true;
      setTimeout(() => {
        this.createCampaign.clear().then(() => {
          window.scroll(0, 0);
          this.layoutService.showSideModal.next();
          setTimeout(() => {
            this.createCampaign.loadingCampaignDto = true;
            this.createCampaign.programId = data.programId;
            this.createCampaign.selectedProgramId = data.programId;
            this.createCampaign.selectedCampaignId = data.campaignId;
            this.createCampaign.fromMyCampaigns = data.fromMyCampaigns || false;
            this.createCampaign.retailerName = data.retailerName;
            this.createCampaign.retailerId = data.retailerId;
            this.createCampaign.fromProgramOverview = data.fromProgramOverview;
            this.createCampaign.budgetYear = data.budgetYear,
            this.createCampaign.goToProgramDetails = data.goToProgramDetails;
            this.createCampaign.selectedCampaignId = data.campaignId;
            this.createCampaign.units = [];
            if (data.goToProgramDetails) {
              if (!this.createCampaign.programDto) {
                this.createCampaign.programDto = {} as ProgramDto;
              }
              this.createCampaign.programDto.fiscalYear = data.budgetYear;
              this.createCampaign.programDto.retailerId = data.retailerId;
            }
            this.createCampaign.loadProgram(data.programId);
            this.createCampaign.loadCampaignTheme(data.campaignId);
            this.createCampaign.loadBrands();
            this.createCampaign.loadUnits();
            this.createCampaign.shouldShowJobsToBeDone = false;
          }, 200);
        });
      }, 200);
    });

    this.layoutService.showDeliveryInformation.subscribe(data => {
      this.modalToShow = 'delivery-information';
      this.sideModalActive = true;

      setTimeout(() => {
        this.deliveryInfo.type = data.type;
        this.deliveryInfo.clear().then(() => {
          window.scroll(0, 0);
          this.layoutService.showSideModal.next();

          this.deliveryInfo.selectedProgramId = data.programId;
          this.deliveryInfo.canEdit = data.canEdit;
          this.deliveryInfo.onlyHaveDownloadMethods = data.onlyHaveDownloadMethods;
          this.deliveryInfo.changeReason = data.changeReason;
          this.deliveryInfo.init();
        });
      }, 200);
    });

    this.layoutService.addressBookshowDeliveryInformation.subscribe(data => {
      this.modalToShow = 'addressbook-delivery-information';
      this.sideModalActive = true;

      setTimeout(() => {
        this.addressbookdeliveryInfo.ready = true;
        this.addressbookdeliveryInfo.type = data.type;
        this.addressbookdeliveryInfo.clear().then(() => {
          window.scroll(0, 0);
          this.layoutService.showSideModal.next();

          this.addressbookdeliveryInfo.type = data.type;
          this.addressbookdeliveryInfo.init();
        });
      }, 200);
    });

    this.layoutService.showDeliveryDistributionInformation.subscribe(data => {
      this.modalToShow = 'delivery-distribution';
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();

      setTimeout(() => {
        this.deliveryDistribution.clear();

        this.deliveryDistribution.selectedProgramId = data.programId;
        this.deliveryDistribution.shippingId = data.shippingId;
        this.deliveryDistribution.init();
      }, 200);
    });

    this.layoutService.showMindshare.subscribe(data => {
      this.modalToShow = 'mindshare';
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      this.componentId = data;
      setTimeout(() => {
        if (this.mindshareModal) {
          this.mindshareModal.ready = false;
          this.mindshareModal.componentId = data;
          this.mindshareModal.getComponentData();
        }
      }, 200);
    });

    this.layoutService.newCommunicationRequest.subscribe(data => {
      this.modalToShow = 'new-communication-request';
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      setTimeout(() => {
        if (this.newCommunicationRequest) {
          this.newCommunicationRequest.getReasonforReview();
        }
      }, 200);
    });

    this.layoutService.campaignCartModal.subscribe(programId => {
      this.modalToShow = 'campaign-cart';
      this.programId = programId;
      this.sideModalActive = true;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      setTimeout(() => {
        if (this.campaignCartModal) {
          this.campaignCartModal.ready = false;
          this.campaignCartModal.loading = true;
          this.campaignCartModal.loadProgramAndCampaign();
        }
      }, 200);
    });

    this.layoutService.communicationRequestDetails.subscribe(data => {
      this.modalToShow = 'communication-request-details';
      this.sideModalActive = true;
      this.requestId = data.id;
      this.versionId = data.version;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      setTimeout(() => {
        if (this.communicationRequestDetails) {
          // this.communicationRequestDetails.getCommunicationRequestInfo();
        }
      }, 200);
    });

    this.layoutService.newProfileVersion.subscribe(data => {
      this.modalToShow = 'profile-version';
      this.sideModalActive = true;
      this.dto = data;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      setTimeout(() => {
        if (this.communicationRequestDetails) {
          // this.communicationRequestDetails.getCommunicationRequestInfo();
        }
      }, 200);
    });

    this.layoutService.newProfileApproval.subscribe(data => {
      this.modalToShow = 'profile-approval';
      this.sideModalActive = true;
      this.dto = data;
      window.scroll(0, 0);
      this.layoutService.showSideModal.next();
      setTimeout(() => {
        if (this.communicationRequestDetails) {
          // this.communicationRequestDetails.getCommunicationRequestInfo();
        }
      }, 200);
    });

    this.layoutService.showLoading.subscribe(data => {
      this.showLoading = data;
      if (data) {
        this.startLoading();
      } else {
        this.stopLoading();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.showModalSubscriber) {
      this.showModalSubscriber.unsubscribe();
    }

    if (this.hideModalSubscriber) {
      this.hideModalSubscriber.unsubscribe();
    }
  }

  closeModal() {
    this.sideModalActive = false;
  }

  loadingtimer;
  currentLoadingItem = 0;
  loadingItemsCount = 4;
  startLoading () {
    this.loadingtimer = setInterval(() => {
      if (this.currentLoadingItem >= this.loadingItemsCount - 1) {
        this.currentLoadingItem = 0;
      } else {
        this.currentLoadingItem += 1;
      }
    }, 200);
  }

  stopLoading () {
    if (this.loadingtimer) {
      clearInterval(this.loadingtimer);
    }
  }

  loadingItemsArray () {
    return new Array(this.loadingItemsCount);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/app-layouts/main-layout.component.ts